
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getUserList, userExport } from '@/api/statistics';
import { UserModule } from '../../store/modules/user';

@Component({
  name: 'StatisticsStaff',
  components: {
  }
})
export default class extends Vue {
  private formSearch:any = {
    name: '',
    timePeriods: ''
  }
  private pagination:any={
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private loading = false
  private tableData = []
  private selectedData: string[] = [];
  handleSelected(val:any[]) {
    this.selectedData = [];
    for (const item of val) {
      this.selectedData.push(item);
    }
  }
  // 导出Excel
  handleExport() {
    let engineerId:any = '';
    let engineerName:any = '';
    if (this.selectedData && this.selectedData.length > 0) {
      for (var eng of this.selectedData) {
        engineerId = engineerId + (eng as any).user_id + ',';
        engineerName = engineerName + (eng as any).user_name + ',';
      }
    }
    let orderParams:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName
    };
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      orderParams.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      orderParams.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    if (this.formSearch.name) {
      orderParams.name = this.formSearch.name;
    }
    if (engineerId) {
      orderParams.engineer_id = engineerId.substring(0, engineerId.length - 1);
    }
    userExport(orderParams).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private settingColumnItem = false
  private columnItemData: any = {
    all: { name: '全选', value: '0', checked: true },
    name: { name: '姓名', value: '1', checked: true },
    taskall: { name: '总任务', value: '2', checked: true },
    finished: { name: '已完成', value: '3', checked: true },
    finished24Hours: { name: '24小时完成数', value: '4', checked: true },
    closed: { name: '上报/转派/关闭', value: '5', checked: true },

    send: { name: '送修', value: '6', checked: true },
    remote: { name: '远程', value: '7', checked: true },
    door: { name: '上门', value: '8', checked: true },
    express: { name: '寄修', value: '9', checked: true },
    other: { name: '其他', value: '10', checked: true },

    doorHourall: { name: '总上门工时', value: '11', checked: true },
    repairHourall: { name: '总维修时长', value: '12', checked: true },

    averageResponse: { name: '平均响应时长', value: '13', checked: true },
    averageRecovery: { name: '平均恢复时长', value: '14', checked: true },
    orderRate24Hours: { name: '24小时订单完成率', value: '15', checked: true },

    assign: { name: '指派', value: '16', checked: true },
    operation: { name: '操作', value: '17', checked: true }
  }
  showHideColumn() {
    this.settingColumnItem = !this.settingColumnItem;
  }
  setColumnItem() {
    this.settingColumnItem = true;
  }

  created() {
    let body = document.documentElement || document.body;
    body.addEventListener('click', (e: any) => {
      if (e.target.id !== 'getColumnItemBtn') {
        this.settingColumnItem = false;
      }
    }, false);
    let dataStrStart = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + '1 00:00:00';
    let dataStrEnd = new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + (new Date().getDate() === 1 ? 1 : (new Date().getDate() - 1)) + ' 23:59:59';
    this.formSearch.timePeriods = [ new Date(dataStrStart).getTime(), new Date(dataStrEnd).getTime() ];
    this.getList();
  }

  getList() {
    let orderParams:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    if (this.formSearch.timePeriods && this.formSearch.timePeriods.length === 2) {
      orderParams.start_time = parseInt(this.formSearch.timePeriods[0]) / 1000;
      orderParams.end_time = parseInt(this.formSearch.timePeriods[1]) / 1000;
    }
    if (this.formSearch.name) {
      orderParams.name = this.formSearch.name;
    }
    this.loading = true;
    getUserList(orderParams).then(res => {
      if (res && res.data) {
        this.pagination.total = parseInt(res.data.count);
        this.tableData = res.data.list;
      } else {
        this.pagination.total = 0;
        this.tableData = [];
      }
      this.loading = false;
    }).catch(err => {
      if (!err.data) {
        this.tableData = [];
        this.loading = false;
      }
      // this.showErrorMsg(err.msg);
    });
  }

  private handleTask(val: any) {
    this.$router.push({
      path: 'staffTask',
      query: {
        user: JSON.stringify(val)
      }
    });
  }

  private cid: string = '';
  private sid: string = ''

  handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  handleClear() {
    this.formSearch = {
      name: '',
      timePeriods: []
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
